import type { Dispatch, SetStateAction } from 'react'

import { useState } from 'react'

const usePagination = (
  total: number,
  initialSize: number,
  initialPage = 1
): [number, number, number, Dispatch<SetStateAction<number>>, Dispatch<SetStateAction<number>>] => {
  const [pageSize, setPageSize] = useState(initialSize)
  const [currentPage, setCurrentPage] = useState(initialPage)

  return [currentPage, pageSize, total, setPageSize, setCurrentPage]
}

export default usePagination
